export const supportedLanguages = ['it', 'en'];
export const defaultLanguage = ['en'];